import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import { PAYMENTPAGE } from "npmlinks-constants";
import OtpV2 from "../../OtpV2";

@inject("CheckoutStore", "LoyaltyStore", "LoginStore")
@observer
class LoyaltyOtp extends Component {
  constructor() {
    super();
    this.state = {
      generateOtpReqBody: {},
      validateOtpReq: {},
    };
    this.afterValidationCallBack = this.afterValidationCallBack.bind(this);
    this.afterGenerateOtpCallBack = this.afterGenerateOtpCallBack.bind(this);
  }

  componentDidMount() {
    this.setState({
      generateOtpReqBody: {
        mobileNumber: this.props.LoginStore.mobileNumber,
      },
    });
  }

  afterGenerateOtpCallBack(generateOtpResponse) {
    const { mobileNumber } = this.props.LoginStore;
    const { state, sessionID } = generateOtpResponse;
    if (generateOtpResponse) {
      this.setState({
        validateOtpReq: {
          mobileNumber,
          state,
          sessionID,
        },
      });
    }
  }

  afterValidationCallBack = otpValidateInfo => {
    if (otpValidateInfo && otpValidateInfo.data) {
      //this.props.loyaltyCheck(true);
      this.props.LoyaltyStore.setLoyaltyVerified(true);
      /* this.props.CodStore.setCodVerified(true);
      this.props.CheckoutStore.setMobileNumberVerified(); */
    }
  };

  render() {
    return (
      <OtpV2.component
        generateOtpReqBody={this.state.generateOtpReqBody}
        validateOtpReq={this.state.validateOtpReq}
        otpHeading={PAYMENTPAGE.LOYALTY_OTP_HEADING}
        otpSubHeading={PAYMENTPAGE.LOYALTY_POINTS_TEXT}
        afterGenerateOtpCallBack={this.afterGenerateOtpCallBack}
        afterValidationCallBack={this.afterValidationCallBack}
      />
    );
  }
}

LoyaltyOtp.wrappedComponent.propTypes = {
  CheckoutStore: PropTypes.shape({
    pricingOverviewData: PropTypes.shape({
      total: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  LoginStore: PropTypes.shape({
    mobileNumber: PropTypes.string.isRequired,
  }).isRequired,
  LoyaltyStore: PropTypes.shape({
    setLoyaltyVerified: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("CheckoutStore", "LoyaltyStore", "LoginStore")(observer(component));

const projectComponent = {
  getFinalComponent,
  wrapper: LoyaltyOtp.wrappedComponent,
  component: LoyaltyOtp,
};

export default projectComponent;



// WEBPACK FOOTER //
// ./src/component/Loyalty/LoyaltyOtp/index.js